import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Col, Row } from "react-bootstrap";
import { SparklinesBars, SparklinesLine, Sparklines } from "react-sparklines";
import loadable from "@loadable/component";
import pMinDelay from "p-min-delay";
import { BgCard } from "../../../elements/CardDesign";
import { IMAGES, SVGICON } from "../../../constant/theme";
import CkEditorBlog from "../../../elements/CkEditor/CkEditorBlog";
import {
  getDashboardStats,
  getDashboardSummary,
  getHighDemandPackages,
  getOverDueSummary,
  getPackagesByPayments,
  getPackageSummary,
  getPaymentModeSummary,
  getRegistrationSummary,
  getRemidersSent,
  getUpcomingDues,
} from "../../../../services/academicService";
import ExpenseAreaChart from "../../../elements/dashboard/ExpenseAreaChart";
import DefaultCard from "../../widget/DefaultCard";
import { getSADashboardSummary } from "../../../../services/TenantsService";

//Charts
const SurveyChart = loadable(() =>
  pMinDelay(import("../../../elements/dashboard/SurveyChart"), 500),
);
const DonughtChart = loadable(() =>
  pMinDelay(import("../../../elements/dashboard/DonughtChart"), 500),
);
const University = loadable(() =>
  pMinDelay(import("../../../elements/dashboard/University"), 500),
);

const bgCarddBlog = [
  {
    title: "Total Tenant",
    number: "3180",
    icon: <i className="la la-users" />,
    percent: "80%",
    color: "primary",
  },
  {
    title: "Total User",
    number: "360",
    icon: <i className="la la-user" />,
    percent: "50%",
    color: "warning",
  },
  {
    title: "Total Course",
    number: "28",
    icon: <i className="la la-graduation-cap" />,
    percent: "60%",
    color: "secondary",
  },
  {
    title: "Fees Collection",
    number: "1290$",
    icon: <i className="la la-dollar" />,
    percent: "35%",
    color: "danger",
  },
];

const detailCard = [
  {
    title: "When Is the Best Time to Take an Education Course?",
    name: "Jack Ronan",
    image: IMAGES.course1,
  },
  {
    title: "Education Courses: A Guide to Unlocking Your Potential",
    name: "Jimmy Morris",
    image: IMAGES.course2,
  },
  {
    title: "A Comprehensive Guide to Taking an Education Course",
    name: "Konne Backfield",
    image: IMAGES.course3,
  },
  {
    title: "Why Should You Consider Taking an Education Course?",
    name: "Nashid Martines",
    image: IMAGES.course4,
  },
];

const examTable = [
  { roll: "542", name: " Jack Ronan" },
  { roll: "360", name: "Jimmy Morris" },
  { roll: "450", name: "Samantha" },
  { roll: "296", name: "Roman Aurora" },
  { roll: "520", name: "Nashid Martines" },
  { roll: "620", name: "Daigno" },
];

const tabelData = [
  {
    no: "01",
    name: "Jack Ronan",
    proff: "Airi Satou",
    date: "02 jan 2024",
    status: "Checkin",
    color: "primary",
    subject: "Commerce",
    fees: "120",
  },
  {
    no: "02",
    name: "Jimmy Morris",
    proff: "Angelica Ramos",
    date: "02 jan 2024",
    status: "Pending",
    color: "warning",
    subject: "Mechanical",
    fees: "205",
  },
  {
    no: "03",
    name: "Nashid Martines",
    proff: "Ashton Cox",
    date: "04 jan 2024",
    status: "Canceled",
    color: "danger",
    subject: "Science",
    fees: "180",
  },
  {
    no: "04",
    name: "Roman Aurora",
    proff: "Cara Stevens",
    date: "05 jan 2024",
    status: "Process",
    color: "info",
    subject: "Arts",
    fees: "200",
  },
  {
    no: "05",
    name: "Samantha",
    proff: "Bruno Nash",
    date: "06 jan 2024",
    status: "Checkin",
    color: "primary",
    subject: "Maths",
    fees: "210",
  },
];

const SuperAdminDasboard = () => {
  const [dashboardStats, setDashboardStats] = useState({});
  const [registrationSummary, setRegistrationSummary] = useState({
    totalPackagesPurchased: 0,
    graph: [],
  });
  const [packageSummary, setPackageSummary] = useState({
    totalPackagesPurchased: 0,
    graph: [],
  });
  const [highDemandPackages, setHighDemandPackages] = useState({});
  const [packagePaymentData, setPackagePaymentData] = useState({});
  const [upcomingDues, setUpcomingDues] = useState({});
  const [overDueSummary, setOverDueSummary] = useState({});
  const [remendersSent, setRemendersSent] = useState({});
  const [paymentMode, setPaymentMode] = useState({});

  const formatAmount = (value) => {
    if (value === null || value === undefined || value === "") return "0";

    const num = Number(value);

    const format = (n, suffix) => {
      const val = parseFloat(n.toFixed(1));
      return `${val}${suffix}`;
    };

    if (num >= 10000000) {
      return format(num / 10000000, "Cr");
    }

    if (num >= 100000) {
      return format(num / 100000, "L");
    }

    if (num >= 1000) {
      return format(num / 1000, "K");
    }

    return num.toString();
  };

  const fetchRegistrationSummary = async () => {
    try {
      const res = await getRegistrationSummary();

      setRegistrationSummary(res);
    } catch (err) {
      console.log(err);
    }
  };

  const fetchPackageSummary = async () => {
    try {
      const res = await getPackageSummary();

      setPackageSummary(res);
    } catch (err) {
      console.log(err);
    }
  };

  const fetchHighDemandPackages = async () => {
    try {
      const res = await getHighDemandPackages();
      setHighDemandPackages(res);
    } catch (err) {
      console.log(err);
    }
  };

  const fetchPackagesByPayment = async () => {
    try {
      const res = await getPackagesByPayments();
      setPackagePaymentData(res);
    } catch (err) {
      console.log(err);
    }
  };

  const fetchUpcomingDues = async () => {
    try {
      const res = await getUpcomingDues();
      setUpcomingDues(res);
    } catch (err) {
      console.log(err);
    }
  };

  const fetchOverDueSummary = async () => {
    try {
      const res = await getOverDueSummary();
      setOverDueSummary(res);
    } catch (err) {
      console.log(err);
    }
  };

  const fetchRemenderSent = async () => {
    try {
      const res = await getRemidersSent();
      setRemendersSent(res);
    } catch (err) {
      console.log(err);
    }
  };

  const fetchPaymentMode = async () => {
    try {
      const res = await getPaymentModeSummary();
      setPaymentMode(res);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchDasboardStats();
  }, []);

  const fetchDasboardStats = async () => {
    try {
      const res = await getSADashboardSummary();
      if (res) {
        setDashboardStats(res);
        console.log("Dashboard Stats:", res);
      }
    } catch (error) {
      console.error("Error fetching dashboard stats:", error);
      setDashboardStats(null); // safe fallback
    }
  };

  const previousMonthName = new Date(
    new Date().getFullYear(),
    new Date().getMonth() - 1,
  ).toLocaleString("default", { month: "short" });

  const bgCarddBlog = dashboardStats
    ? [
        {
          title: "Total User",
          number: dashboardStats?.totalPlayers,
          icon: <i className="la la-users" />,
          percent: "80%",
          color: "primary",
        },
        {
          title: "Active Tenants",
          number: dashboardStats?.newPlayers,
          icon: <i className="la la-user" />,
          percent: "50%",
          color: "warning",
        },
        {
          title: "Total Packages",
          number: dashboardStats?.totalCourses,
          icon: <i className="la la-graduation-cap" />,
          percent: "60%",
          color: "secondary",
        },
        {
          title: "Fees Collection",
          number: `₹ ${dashboardStats?.feesCollections}`,
          icon: <i className="la la-dollar" />,
          percent: "35%",
          color: "danger",
        },
      ]
    : [];

  const bgCarddBlogs = dashboardStats
    ? [
        {
          title: "Collection Trend",
          number: dashboardStats?.totalPlayers,
          icon: <i className="la la-users" />,
          percent: "80%",
          color: "primary",
        },
        {
          title: "Top Players View Top 5",
          number: dashboardStats?.newPlayers,
          icon: <i className="la la-user" />,
          percent: "50%",
          color: "warning",
        },
        {
          title: "Avg Player per collection",
          number: dashboardStats?.totalCourses,
          icon: <i className="la la-graduation-cap" />,
          percent: "60%",
          color: "secondary",
        },
        {
          title: "Package Status",
          number: `₹ ${dashboardStats?.feesCollections}`,
          icon: <i className="la la-dollar" />,
          percent: "35%",
          color: "danger",
        },
      ]
    : [];

  const cardBlog = [
    {
      title: "Total Academies",
      number: dashboardStats?.totalActiveTenants,
      icon: SVGICON.user,
      // percent: `+${dashboardStats?.playersGrowth || 0} this month`,
      color: "primary",
    },
    {
      title: "Total Users",
      number: dashboardStats?.totalUsers,
      icon: SVGICON.bills,
      // percent: `+${dashboardStats?.packagesGrowth || 0} this month`,
      color: "warning",
    },
    {
      title: "Pending Academies",
      number: dashboardStats?.pendingTenants,
      icon: SVGICON.grid,
      // percent: `₹${formatAmount(dashboardStats?.upcomingRenewalAmount)}`,
      color: "success",
    },
    {
      title: "Total Collection",
      number: `₹${formatAmount(dashboardStats?.totalCollection)}`,
      icon: SVGICON.revenue,
      // percent: `${dashboardStats?.collectionGrowth || 0}% Vs ${previousMonthName}`,
      color: "danger",
    },
  ];

  const upcomingRenewalRows = [
    {
      label: "Within 7 Days",
      count: upcomingDues?.within7Days?.count,
      amount: upcomingDues?.within7Days?.amount,
    },
    {
      label: "8 - 15 Days",
      count: upcomingDues?.eightToFifteenDays?.count,
      amount: upcomingDues?.eightToFifteenDays?.amount,
    },
    {
      label: "16 - 30 Days",
      count: upcomingDues?.sixteenToThirtyDays?.count,
      amount: upcomingDues?.sixteenToThirtyDays?.amount,
    },
    {
      label: "30+ Days",
      count: upcomingDues?.thirtyPlusDays?.count,
      amount: upcomingDues?.thirtyPlusDays?.amount,
    },
  ];

  const upcomingNoRenewalRows = [
    {
      label: "1 - 15 Days Overdue",
      count: overDueSummary?.oneToFifteenDays?.count,
      amount: overDueSummary?.oneToFifteenDays?.amount,
    },
    {
      label: "16 - 30 Days Overdue",
      count: overDueSummary?.sixteenToThirtyDays?.count,
      amount: overDueSummary?.sixteenToThirtyDays?.amount,
    },
    {
      label: "31 - 60 Days Overdue",
      count: overDueSummary?.sixtyPlusDays?.count,
      amount: overDueSummary?.sixtyPlusDays?.amount,
    },
    {
      label: "60+ Days Overdue",
      count: overDueSummary?.thirtyOneToSixtyDays?.count,
      amount: overDueSummary?.thirtyOneToSixtyDays?.amount,
    },
  ];

  const reminderSentRows = [
    {
      label: "Today",
      count: remendersSent?.today?.count,
      amount: remendersSent?.today?.amount,
    },
    {
      label: "This Week",
      count: remendersSent?.thisWeek?.count,
      amount: remendersSent?.thisWeek?.amount,
    },
    {
      label: "This Month",
      count: remendersSent?.thisMonth?.count,
      amount: remendersSent?.thisMonth?.amount,
    },
  ];

  return (
    <>
      <Row>
        {cardBlog.map((item, index) => (
          <Col xl={3} xxl={6} lg={6} sm={6} key={index}>
            <div className="widget-stat card">
              <div className="card-body p-4">
                <DefaultCard
                  title={item.title}
                  number={item.number}
                  percent={item.percent}
                  icon={item.icon}
                  color={item.color}
                />
              </div>
            </div>
          </Col>
        ))}

        {/* {bgCarddBlog?.map((item, index) => (
          <Col xl={"3"} xxl={"3"} sm={"6"} key={index}>
            <div className={`widget-stat card bg-${item?.color}`}>
              <div className="card-body">
                <BgCard
                  title={item?.title}
                  number={item?.number}
                  percent={item?.percent}
                  color={item?.color}
                  icon={item?.icon}
                />
              </div>
            </div>
          </Col>
        ))} */}

        {/* <Col xl={3} xxl={6} lg={6} sm={6}>
          <div className="card">
            <div className="card-header">
              <h3 className="card-title">Registration Summary</h3>
            </div>

            <div className="card-body">
              <ExpenseAreaChart
                total={registrationSummary.totalRegistrations}
                graph={registrationSummary.graph}
              />
            </div>
          </div>
        </Col> */}

        {/* <div className="col-xl-6 col-xxl-6 col-sm-6">
          <div className="card">
            <div className="card-header">
              <h3 className="card-title">Package Purchase</h3>
            </div>

            <div className="card-body">
              <ExpenseAreaChart
                total={packageSummary.totalPackagesPurchased}
                graph={packageSummary.graph}
              />
            </div>
          </div>
        </div> */}

        {/* <Col xl={6} xxl={6} sm={6}>
          <div className="card">
            <div className="card-header">
              <h3 className="card-title">High Demand Packages</h3>
            </div>
            <div className="card-body">
              {/* <DonughtChart /> */}
              {/* <DonughtChart
                data={highDemandPackages.packages}
                total={highDemandPackages.totalPlayers}
              />
            </div>
          </div>
        </Col> */} 

        {/* <Col xl={6} lg={6} xxl={6} md={12}>
          <div className="card">
            <div className="card-header">
              <h4 className="card-title">Package Wise Payment Collected</h4>
            </div>

            <div className="card-body pt-2">
              <div className="table-responsive recentOrderTable">
                <table className="table verticle-middle text-nowrap table-responsive-md">
                  <thead>
                    <tr>
                      <th>No.</th>
                      <th>Package</th>
                      <th className="text-end">Amount</th>
                    </tr>
                  </thead>

                  <tbody>
                    {packagePaymentData?.packages?.map((item, index) => (
                      <tr key={item.packageId}>
                        <td>{index + 1}</td>
                        <td>{item.packageName}</td>
                        <td className="text-end">
                          ₹ {formatAmount(item.amountCollected)}(
                          {item.percentage}%)
                        </td>
                      </tr>
                    ))}

                    {/* Total Row */}
                    {/* {packagePaymentData && (
                      <tr className="fw-bold border-top">
                        <td colSpan={2}>Total</td>
                        <td className="text-end">
                          ₹
                          {formatAmount(
                            packagePaymentData?.totalAmountCollected,
                          )}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </Col> */} 

        {/* <Col xl={6} lg={6} xxl={6} md={12}>
          <div className="card">
            <div className="card-header">
              <h4 className="card-title">Upcoming Renewals / Dues</h4>
            </div>

            <div className="card-body pt-2">
              <div className="table-responsive">
                <table className="table table-borderless align-middle">
                  <thead>
                    <tr>
                      <th>Duration</th>
                      <th className="text-center">Package</th>
                      <th className="text-end">Amount</th>
                    </tr>
                  </thead>

                  <tbody>
                    {upcomingRenewalRows.map((item, index) => (
                      <tr key={index}>
                        <td>{item.label}</td>

                        <td className="text-center fw-semibold">
                          {item.count}
                        </td>

                        <td className="text-end fw-semibold">
                          ₹ {formatAmount(item.amount)}
                        </td>
                      </tr>
                    ))}

                    <tr
                      style={{
                        borderTop: "2px solid #dee2e6",
                        fontWeight: 700,
                        color: "#198754",
                      }}
                    >
                      <td>TOTAL</td>

                      <td className="text-center">
                        {upcomingDues?.totalCount}
                      </td>

                      <td className="text-end">
                        ₹ {formatAmount(upcomingDues?.totalAmount)}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </Col> */}

        {/* <Col xl={6} lg={6} xxl={6} md={12}>
          <div className="card">
            <div className="card-header">
              <h4 className="card-title">No Renewals / Dues not Paid</h4>
            </div>

            <div className="card-body pt-2">
              <div className="table-responsive">
                <table className="table table-borderless align-middle">
                  <thead>
                    <tr>
                      <th>Duration</th>
                      <th className="text-center">Package</th>
                      <th className="text-end">Amount</th>
                    </tr>
                  </thead>

                  <tbody>
                    {upcomingNoRenewalRows.map((item, index) => (
                      <tr key={index}>
                        <td>{item.label}</td>

                        <td className="text-center fw-semibold">
                          {item.count}
                        </td>

                        <td className="text-end fw-semibold">
                          ₹ {formatAmount(item.amount)}
                        </td>
                      </tr>
                    ))}

                    <tr
                      style={{
                        borderTop: "2px solid #dee2e6",
                        fontWeight: 700,
                        color: "#198754",
                      }}
                    >
                      <td>TOTAL</td>

                      <td className="text-center">
                        {overDueSummary?.totalCount}
                      </td>

                      <td className="text-end">
                        ₹ {formatAmount(overDueSummary?.totalAmount)}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </Col> */}

        {/* <Col xl={6} lg={6} xxl={6} md={12}>
          <div className="card">
            <div className="card-header">
              <h4 className="card-title">Reminders Sent</h4>
            </div>

            <div className="card-body pt-2">
              <div className="table-responsive">
                <table className="table table-borderless align-middle">
                  <thead>
                    <tr>
                      <th>Duration</th>
                      <th className="text-center">Players</th>
                      <th className="text-end">Amount</th>
                    </tr>
                  </thead>

                  <tbody>
                    {reminderSentRows.map((item, index) => (
                      <tr key={index}>
                        <td>{item.label}</td>

                        <td className="text-center fw-semibold">
                          {item.count || 0}
                        </td>

                        <td className="text-end fw-semibold">
                          ₹ {formatAmount(item.amount) || 9}
                        </td>
                      </tr>
                    ))}

                    <tr
                      style={{
                        borderTop: "2px solid #dee2e6",
                        fontWeight: 700,
                        color: "#198754",
                      }}
                    >
                      <td>TOTAL</td>

                      <td className="text-center">
                        {remendersSent?.total?.count || 0}
                      </td>

                      <td className="text-end">
                        ₹ {formatAmount(remendersSent?.total?.amount)}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </Col> */}

        {/* <Col xl={6} lg={6} xxl={6} md={12}>
          <div className="card">
            <div className="card-header">
              <h4 className="card-title">Mode & Payments</h4>
            </div>

            <div className="card-body pt-2">
              <div className="table-responsive">
                <table className="table table-borderless align-middle">
                  <thead>
                    <tr>
                      <th>Payment Mode</th>
                      <th className="text-center">Package</th>
                      <th className="text-end">Amount</th>
                    </tr>
                  </thead>

                  <tbody>
                    {paymentMode?.paymentModes?.map((item, index) => (
                      <tr key={index}>
                        <td>{item.paymentMode}</td>

                        <td className="text-center fw-semibold">
                          {item.count}
                        </td>

                        <td className="text-end fw-semibold">
                          ₹ {formatAmount(item.amount)}
                        </td>
                      </tr>
                    ))}

                    <tr
                      style={{
                        borderTop: "2px solid #dee2e6",
                        fontWeight: 700,
                        color: "#198754",
                      }}
                    >
                      <td>TOTAL</td>

                      <td className="text-center">
                        {formatAmount(paymentMode?.totalCount)}
                      </td>

                      <td className="text-end">
                        ₹ {formatAmount(paymentMode?.totalAmount)}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </Col> */}

        {/* {bgCarddBlogs?.map((item, index) => (
          <Col xl={"3"} xxl={"3"} sm={"6"} key={index}>
            <div className={`widget-stat card bg-${item?.color}`}>
              <div className="card-body">
                <BgCard
                  title={item?.title}
                  number={item?.number}
                  percent={item?.percent}
                  color={item?.color}
                  icon={item?.icon}
                />
              </div>
            </div>
          </Col>
        ))} */}
      </Row>
    </>
  );
};
export default SuperAdminDasboard;
